import { get } from 'lodash-es';
import { useSelector } from 'react-redux';

import { uncurlyUuid } from '@atlassian/bitkit-analytics';

import {
  getCurrentPullRequestId,
  getPullRequestDestinationRepo,
  getPullRequestSourceRepo,
} from 'src/redux/pull-request/selectors';

export const usePullRequestFactData = () => {
  const sourceRepo = useSelector(getPullRequestSourceRepo);
  const destRepo = useSelector(getPullRequestDestinationRepo);
  const pullRequestId = useSelector(getCurrentPullRequestId);

  const prFactData = {
    from_repository_uuid: uncurlyUuid(get(sourceRepo, 'uuid', '')),
    pull_request_id: pullRequestId,
    to_repository_uuid: uncurlyUuid(get(destRepo, 'uuid', '')),
    to_repository_owner_uuid: uncurlyUuid(get(destRepo, 'owner.uuid', '')),
  };

  return prFactData;
};
